import React from 'react';
import LogComponent from '../Elements/LogComponent';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import TaxComponent from '../Elements/TaxComponent';
import LookupText from '../Elements/LookupText';
import RelatedContacts from '../Contents/Sales/ContactAdmin/RelatedContacts';
import FigmaBadge from '../Elements/FigmaBadge';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import urlHelper from '../Helpers/urlHelper';

export default class ContactItem {
  constructor(item) {
    const date = new Date();
    const today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    if (item === undefined) {
      this.AddressId = '';
      this.AllowBulkEmail = 'false';
      this.AllowEmail = 'false';
      this.AllowFax = 'false';
      this.AllowPhone = 'false';
      this.AllowPostalMail = 'false';
      this.AllowSendMedia = 'false';
      this.BillToClientName = '';
      this.Birthday = today;
      this.BusinessPhone = '';
      this.ClientId = '';
      this.Comments = '';
      this.ContactId = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.Email = '';
      this.Fax = '';
      this.FirstName = '';
      this.HomePhone = '';
      this.IsActive = true;
      this.JobTitle = '';
      this.LastName = '';
      this.MeadId = '';
      this.MobilePhone = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.Name = '';
      this.OfficeId = '';
      this.OtherPhone = '';
      this.PrefContactMethodCode = 1;
      this.Salutation = '';
      this.SapbillToContactId = '';
      this.TimeZoneOffset = '';
      this.Utcoffset = '';
      this.Vatnumber = '';
      this.WebSiteUrl = '';
      this.OfficeName = '';
      this.ClientName = '';
      this.LeadName = '';
      this.AddressName = '';
      this.AddressTypeCode = '';
      this.AddressPostalCode = '';
      this.AddressCity = '';
      this.AddressLine1 = '';
      this.AddressState = '';
      this.AddressCountryId = '';
      this.AddressCountryName = '';
      this.CreatedByUserName = '';
      this.ModifiedByUserName = '';
      return;
    }
    this.AddressId = item.addressId;
    this.AllowBulkEmail = item.allowBulkEmail;
    this.AllowEmail = item.allowEmail;
    this.AllowFax = item.allowFax;
    this.AllowPhone = item.allowPhone;
    this.AllowPostalMail = item.allowPostalMail;
    this.AllowSendMedia = item.allowSendMedia;
    this.BillToClientName = item.billToClientName;
    this.Birthday = item.birthday === null ? today : item.birthday;
    this.BusinessPhone = item.businessPhone;
    this.ClientId = item.clientId;
    this.Comments = item.comments;
    this.ContactId = item.contactId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.Email = item.email;
    this.Fax = item.fax;
    this.FirstName = item.firstName;
    this.HomePhone = item.homePhone;
    this.IsActive = item.isActive;
    this.JobTitle = item.jobTitle;
    this.LastName = item.lastName;
    this.LeadId = item.leadId;
    this.MobilePhone = item.mobilePhone;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.Name = item.name;
    this.OfficeId = item.officeId;
    this.OtherPhone = item.otherPhone;
    this.PrefContactMethodCode = item.prefContactMethodCode;
    this.Salutation = item.salutation;
    this.SapbillToContactId = item.sapbillToContactId;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.Utcoffset = item.utcoffset;
    this.Vatnumber = item.vatnumber;
    this.WebSiteUrl = item.webSiteUrl;
    this.OfficeName = item.officeName;
    this.ClientName = item.clientName;
    this.LeadName = item.leadName;
    this.AddressName = item.addressName;
    this.AddressTypeCode = item.addressTypeCode;
    this.AddressPostalCode = item.addressPostalCode;
    this.AddressCity = item.addressCity;
    this.AddressLine1 = item.addressLine1;
    this.AddressState = item.addressState;
    this.AddressCountryId = item.addressCountryId;
    this.AddressCountryName = item.addressCountryName;
    this.CreatedByUserName = item.createdByUserName;
    this.ModifiedByUserName = item.modifiedByUserName;
  }

  static NameOfTheIdField() {
    return 'ContactId';
  }
  static nameOfTheItemDetailList() {
    return 'Contact';
  }

  static MoneyFields = [];

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 11, entityId: item.ContactId }}
      />
    );
  }

  static getRelatedContactsContent(item) {
    return (
      <RelatedContacts
        contactOwnId={item.ContactId}
        clientId={item.ClientId}
      />
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='Contact'
        entityId={item.ContactId}
      />
    );
  }

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={11}
        entityId={item.ContactId}
      />
    );
  }

  static getViewTaxContent(item) {
    return (
      <div>
        <TaxComponent
          entityTypeId={11}
          entityId={item.ContactId}
          isActiveSlide={false}
          showEdit={false}
          showAssociateTaxLink={true}
          officeId={item.OfficeId}
        />
      </div>
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static lockFunction = (id, item, itemList) => {};

  static commentFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'ModifiedOn'];

  static BoolFields = ['IsActive'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'FirstName', label: 'First Name' },
        { name: 'OfficeName', label: 'Office' },
        { name: 'BusinessPhone', label: 'Business Phone' },
        { name: 'LastName', label: 'Last Name' },
        { name: 'Vatnumber', label: 'Tax Number' },
        { name: 'MobilePhone', label: 'Mobile Phone' },
        { name: 'JobTitle', label: 'Title' },
        { name: 'Email', label: 'E-mail' },
        { name: 'HomePhone', label: 'Home Phone' },
        {
          name: (item) => `${item.ClientName}(${item.ClientId})`,
          label: 'Client',
        },
        {
          name: (item) => urlHelper.getLinkComponent(item.WebSiteUrl),
          label: 'Website Url',
        },
        { name: 'OtherPhone', label: 'Other Phone' },
        { name: 'BillToClientName', label: 'Bill to Client' },
        { name: 'SapbillToContactId', label: 'SAP Bill to Contact Id' },
        { name: 'Fax', label: 'Fax' },
        {
          name: (item) => (item.LeadId === null ? '' : `${item.LeadName}(${item.LeadId})`),
          label: 'Lead',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={9}
              value={item.PrefContactMethodCode}
            />
          ),
          label: 'Preferred contact method',
        },
        { name: '-', label: '' },
        {
          name: 'Comments',
          label: 'Comments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowEmail),
          label: 'Allow Email',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowPhone),
          label: 'Allow Phone',
        },
        { name: (item) => JsxHelper.YesNo(item.AllowFax), label: 'Allow Fax' },
        {
          name: (item) => JsxHelper.YesNo(item.AllowBulkEmail),
          label: 'Allow Bulk Email',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowPostalMail),
          label: 'Allow Postal Mail',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowSendMedia),
          label: 'Allow Send Media',
        },
        { name: '-message-', label: '' },
        { name: 'CreatedByUserName', label: 'Created By' },
        { name: 'ModifiedByUserName', label: 'Modified By' },
        { name: '', label: '' },
        { name: 'CreatedOn', label: 'Created On' },
        { name: 'ModifiedOn', label: 'Modified On' },
        { name: '', label: '' },
      ],
    },
    {
      tabName: 'Address',
      tabLabel: 'Address',
      icon: 'fa-solid fa-user-slash',
      data: [
        { name: 'AddressName', label: 'Address Name' },
        { name: 'AddressLine1', label: 'Street' },
        { name: 'AddressState', label: 'State' },
        {
          name: (item) => (
            <LookupText
              lookupId={8}
              value={item.AddressTypeCode}
            />
          ),
          label: 'Address Type',
        },
        { name: 'AddressCity', label: 'City' },
        { name: 'AddressCountryName', label: 'Country' },
        { name: '', label: '' },
        { name: 'AddressPostalCode', label: 'Postal Code' },
        { name: '', label: '' },
      ],
    },
    {
      tabName: 'Tax',
      tabLabel: 'Tax',
      icon: 'fa-solid fa-percent',
      data: [
        {
          name: ContactItem.getViewTaxContent,
          label: 'Tax',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        {
          name: ContactItem.getAttachmentContent,
          label: 'Attachments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-regular fa-comment',
      data: [
        {
          name: ContactItem.getCommentsContent,
          label: 'Comments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: '-message-',
          label: 'The comments above are related to the primary user.',
        },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [
        {
          name: ContactItem.getLogContent,
          label: 'Log',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'RelatedContacts',
      tabLabel: 'Related Contacts',
      icon: 'fa-solid fa-address-book',
      data: [
        {
          name: ContactItem.getRelatedContactsContent,
          label: 'Related Contacts',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'ID',
        orderById: 'Name',
        data: 'ContactId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'LastName',
        data: (item) => `${item.LastName}, ${item.FirstName}`,
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Bill to Client Name',
        orderById: 'BillToClientName',
        data: 'BillToClientName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Office',
        orderById: 'OfficeId',
        data: 'OfficeName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Address Name',
        orderById: 'AddressId',
        data: 'AddressName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Phone',
        orderById: 'BusinessPhone',
        data: 'BusinessPhone',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Email',
        orderById: 'Email',
        data: 'Email',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Active?',
        orderById: 'OfficeId',
        data: ContactItem.getIsActiveCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: ' ',
        orderById: 'ContactId',
        data: ContactItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getIsActiveCellContent(item) {
    return <div className='pointer'>{<FigmaBadge Active={item.IsActive} />}</div>;
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            onClick: () => ContactItem.editFunction(item.EvaluatorId, item),
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            roleKey: 'ClientContact_faicon_CreateEdit',
          },
          {
            onClick: () => ContactItem.lockFunction(item.ContactId, item),
            text: item.IsActive ? 'Close Contact' : 'Reopen Contact',
            iconName: item.IsActive ? 'fa-solid fa-lock-open' : 'fa-solid fa-lock',
            roleKey: 'ClientContact_faicon_CreateEdit',
          },
        ]}
      />
    );
  }
}
